import { HiddenFilterKeys, InboxFilters, InboxFiltersButton } from '@frontend/inbox-filters';
import { theme } from '@frontend/theme';
import { InboxStatusFiltersText } from './inbox-status-filters-text';

type MessagesFiltersProps = {
  filters: InboxFilters;
  setFilters: (newVal: InboxFilters) => void;
  hideFilters: HiddenFilterKeys;
};

export const MessagesFilters = ({ filters, setFilters, hideFilters }: MessagesFiltersProps) => {
  const hasFilters = !!filters.tags.length || !!filters.locationPhones?.length;

  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end',
        flexGrow: 1,
        gap: theme.spacing(1),
      }}
    >
      {hasFilters && <InboxStatusFiltersText hideFilters={hideFilters} filters={filters} />}
      <InboxFiltersButton hideFilters={hideFilters} filters={filters} setFilters={setFilters} />
    </div>
  );
};
